define('shared/remote/data/cache',[],function () {
    return {}; 
});
